import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Box, Link, Text } from "pcln-design-system";
const RealtimeToolTipInfo = ({ isRealtime, handleShowRealTimeInfoModal })=>/*#__PURE__*/ jsxs(Box, {
        px: 2,
        "data-testid": "voice-mode-tooltip",
        children: [
            /*#__PURE__*/ jsxs(Text, {
                fontWeight: 'bold',
                children: [
                    " ",
                    isRealtime ? 'Penny Voice, Now Smarter' : 'Introducing Voice Chat'
                ]
            }),
            /*#__PURE__*/ jsxs(Text, {
                children: [
                    ' ',
                    isRealtime ? /*#__PURE__*/ jsxs(Box, {
                        children: [
                            "Real-time travel help with advanced features.",
                            ' ',
                            /*#__PURE__*/ jsx(Link, {
                                onClick: function() {
                                    handleShowRealTimeInfoModal(true);
                                },
                                children: "Learn more"
                            }),
                            "."
                        ]
                    }) : 'Hands-free convenience. Tap the mic to start.'
                ]
            })
        ]
    });
const Voice_RealtimeToolTipInfo = RealtimeToolTipInfo;
export { Voice_RealtimeToolTipInfo as default };
